import { MenuItem } from './route-mapping';

export const newMenus: MenuItem[] = [
    {
        text: 'Admin',
        recId: 0,
        navigateUrl: {},
        children: [
            {
                text: 'Violation Behavior Profiles',
                navigateUrl: { name: 'behaviorProfiles' },
                recId: 0,
                children: []
            },
            {
                text: 'Revenue and Taxes',
                navigateUrl: { name: 'revenue' },
                recId: 1000,
                children: []
            },
            {
                text: 'Vendor Lot Ids',
                navigateUrl: { name: 'vendorLotIds' },
                recId: 1001,
                children: []
            },
            {
                text: 'Ticket Templates',
                navigateUrl: { name: 'ticketTemplates' },
                recId: 1002,
                children: [],
            }
        ]
    }
];
